import type { User } from '@/features/iam/users/User'
import type { Membership } from '@/features/iam/workspaces/Membership'
import { isRefreshDesign } from '@/infra/design'

/**
 * Whether the user may see the workspace's legends, which also decides whether
 * the navigation offers them: with the `adminLegendView` permission, while the
 * workspace uses the legend builder or for platform admins. The legend builder
 * only exists in the refreshed design.
 *
 * @param membership
 * @param user
 */
export function canViewWorkspaceLegends(membership: Membership, user: User) {
  return (
    isRefreshDesign &&
    membership.member.permissions.adminLegendView &&
    (membership.workspace.config.legendsBuilder.enabled || user.platformAdmin)
  )
}

/**
 * Whether the user may edit, publish and (de)activate the workspace's legends.
 *
 * @param membership
 * @param user
 */
export function canModifyLegends(membership: Membership, user: User) {
  return (
    canViewWorkspaceLegends(membership, user) &&
    membership.member.permissions.adminLegendModify
  )
}
